import { Box } from '@theme-ui/components'
import type { ReactNode } from 'react'

const CustomCard = ({ children, classes }: { children: ReactNode, classes?: string }) => {
  return (
    <Box
      className={classes}
      sx={{
        background: 'white',
        padding: ['20px 16px', '20px 30px'],
        borderRadius: ['0 0 8px 8px', '0 0 24px 24px'],
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)',
      }}
    >
      {children}
    </Box>
  )
}

export default CustomCard
